module.exports = __webpack_public_path__ + "img/image1.6f4cfada.png";